import predicates from '../predicates'
import selectors from '../selectors'
import { NAVIGATION_TRAFFIC_SOURCE } from '../constants'

const navigation = {
  rule: predicates.referrerIsSameAsSite(),
  extractor: traffic => {
    const trafficSource = NAVIGATION_TRAFFIC_SOURCE
    const trafficId = selectors.referrerHostname(traffic)

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default navigation



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/navigation.js